<template>
  <div>
    <svg id="chartPrint"></svg>
    <div id="chartInfo" v-if="$route.params.renderType == 'type2'">
       <table style="float: left;" class="examInfo0">
          <tbody>
            <tr>
              <th>{{ $t('thermal.max_flow_rate') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.max_speed }} ml/s</td>
            </tr>
            <tr>
              <th>{{ $t('thermal.time_to_max_flow') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.max_speed_time }} sn</td>
            </tr>
            <tr>
              <th>{{ $t('thermal.voided_volume') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.total_volume }} ml</td>
            </tr>
            <!-- <tr>
          <th>{{ $t("report.reference_number") }}</th>
          <td>:</td>
          <td class="val2">{{ exam_detail.patient.his_patient_id > 0 ? exam_detail.patient.his_patient_id : '-' }}</td>
            </tr>-->
            <tr v-show="exam_detail.pvr && systemConfig.PVREnabled">
              <th>{{ $t('report.pvr') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.pvr }} ml</td>
            </tr>
          </tbody>
        </table>
        <table style="float:right;" class="examInfo0">
          <tbody>
            <tr>
              <th>{{ $t('thermal.voiding_time') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.duration }} sn</td>
            </tr>
            <tr>
              <th>{{ $t('thermal.flow_time') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.flow_time }} sn</td>
            </tr>
            <tr></tr>
            <tr>
              <th>{{ $t('thermal.avg_flow_rate') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.average_speed }} ml/sn</td>
            </tr>
            <tr>
              <th>{{ $t('thermal.delay_time') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.delay_time }} sn</td>
            </tr>
          </tbody>
        </table>
    </div>
    <div id="chartInfo2" v-if="$route.params.renderType == 'type3'">
       <table style="float: left;" class="examInfo2">
          <tbody>
            <tr>
              <th>{{ $t('thermal.max_flow_rate') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.max_speed }} ml/s</td>
            </tr>
            <tr>
              <th>{{ $t('thermal.time_to_max_flow') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.max_speed_time }} sn</td>
            </tr>
            <tr>
              <th>{{ $t('thermal.voided_volume') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.total_volume }} ml</td>
            </tr>
            <tr v-show="exam_detail.pvr && systemConfig.PVREnabled">
              <th>{{ $t('report.pvr') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.pvr }} ml</td>
            </tr>
            <tr>
              <th>{{ $t('thermal.voiding_time') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.duration }} sn</td>
            </tr>
            <tr>
              <th>{{ $t('thermal.flow_time') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.flow_time }} sn</td>
            </tr>
            <tr>
              <th>{{ $t('thermal.delay_time') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.delay_time }} sn</td>
            </tr>
            <tr>
              <th>{{ $t('thermal.avg_flow_rate') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.average_speed }} ml/sn</td>
            </tr>
            <tr>
              <th>{{ $t('thermal.exam_date') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.created }}</td>
            </tr>
            <!-- <tr>
              <th>Test PIN</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.test_pin }}</td>
            </tr>
            <tr>
              <th colspan="3">http://www.oruflow.com</th>
            </tr> -->

          </tbody>
        </table>
        <table style="float:right;" class="examInfo0">
          <tbody>
          </tbody>
        </table>
    </div>
  </div>

</template>

<script>

import GenericChart from '../GenericChart'
import Settings from '../settings'

export default {
  props: ['title'],
  data () {
    return {
      exam_detail: { patient: {} }
    }
  },
  mounted () {
    var examId = this.$route.params.examId
    // var renderType = this.$route.params.renderType

    var vm = this

    var chartConfig = {

      width: 800,
      height: 380,
      margin: { top: 8, bottom: 21, left: 50, right: 10 },
      interpolation: 'monotone',
      tickInterval: 1000,
      orientation: 'vertical',
      axisLabels: 'disabled',
      translation: vm.$t,
      chartType: 'static',
      invisible_points: 0,
      totalTime: 19000,
      tickConfig: {
        verticalTicks: true
      },
      lineStrokeWidth: 1.5 // should match css "stroke-width"
    }

    vm.historyChart = new GenericChart(document.querySelector('svg'), chartConfig)

    Promise.all([
      this.$http.get('http://' + Settings.host + ':6161/' + 'api/exam_detail/' + examId),
      this.$http.get('http://' + Settings.host + ':6161/' + 'api/config')
    ]).then((response) => { // success
      var exam = response[0].data
      vm.systemConfig = response[1].data
      vm.exam_detail = response[0].data

      var w = []
      var s = []
      var e = []

      if (exam.weight_array) {
        w = exam.weight_array.split(' ').map(function (item) { return parseFloat(item, 10) })
        s = exam.speed_array.split(' ').map(function (item) { return parseFloat(item) })
      }

      if (exam.emg_array) {
        e = exam.emg_array.split(' ').map(function (item) { return parseFloat(item) })
      }

      var weight = []
      var speed = []
      var emg = []

      for (let i = 0; i < w.length; i++) {
        let t = new Date(i * 1000)
        weight.push([t, w[i]])
        speed.push([t, s[i]])
      }

      for (let i = 0; i < e.length; i++) {
        let t = new Date(i * 100)
        emg.push([t, e[i]])
      }

      vm.$nextTick(function () {
        vm.historyChart.initDrawing(weight, speed, emg, vm.systemConfig['Chart.Scale'], vm.systemConfig['EMG.Chart.Scale'])

        if (exam.emg_array && weight.length) {
          console.log('Uroflowmetry+EMG result.')
          vm.show_uroflowmetry = true
          vm.historyChart.emgEnable(true)
        } else if (exam.emg_array && !weight.length) {
          console.log('EMG result.')
          vm.show_uroflowmetry = false
          vm.historyChart.emgEnable(true, true)
        } else {
          console.log('Uroflowmetry result.')
          // vm.$nextTick(() => console.log('Uroflowmetry result.'))
          vm.show_uroflowmetry = true
          vm.historyChart.emgEnable(undefined, false)
        }

        vm.$nextTick(function () {
          console.log('STATIC_CHART_LOADED')
        })
      })
    }, (response) => { // error
      console.log(response)
    })
  }
}
</script>

<style>

.examInfo0 {
  line-height: 12pt;
  border-collapse: separate;
  border-spacing: 0.7mm;
  font-size: 13pt;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}

.examInfo0 th {
  text-align: left;
  width: 140px;
  font-weight: bold;
}

.examInfo0 .val1 {
  width: 140px;
}

.examInfo0 .val2 {
  width: 250px;
}

.examInfo2 {
  line-height: 14pt;
  border-collapse: separate;
  border-spacing: 0.7mm;
  font-size: 13pt;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}

.examInfo2 th {
  text-align: left;
  width: 150px;
  font-weight: bold;
}

.examInfo2 .val1 {
  width: 140px;
}

.examInfo2 .val2 {
  width: 250px;
}

#chartInfo {
  position: absolute;
  /* left:380px; */
  left:518px;
  top:100px;
  width:600px;
  height:138px;
  /* background-color: aqua; */

  transform-origin: top left;
  -ms-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

#chartInfo2 {
  position: absolute;
  left:30px;
  /* left:518px; */
  top:800px;
  width:600px;
  height:138px;
  /* background-color: aqua; */

}

#chartPrint .axis {
  font: 15px sans-serif;
  font-weight: bold;
}

#chartPrint .axis path
/* ,#chartPrint .axis line11, #chartPrint .axis line22, #chartPrint .axis line33 */
{
  fill: none;
  shape-rendering: crispEdges;
  /* stroke: black;

  stroke-width: 2.5px; */
}

/* #chartPrint .axis--x line {
stroke: black;
stroke-width: 1.0px;
} */

#chartPrint .axis--y1 line,
#chartPrint .axis--y2 line,
#chartPrint .axis--y3 line {
  stroke: black;
  stroke-width: 1.0px;
  stroke-dasharray: 1, 3;
}

#chartPrint .line1, #chartPrint .line2, #chartPrint .line3 {
  fill: none;
  stroke: black;
  stroke-width: 3.5px;
}

#chartPrint .line3 { stroke: none; }

/* #chartHistory .area { fill: none; } */
#chartPrint .area { fill: black; }

/* below selector disabled. see GenericChart.js (hacky way to add right line of square around chart) */
/* #chartPrint .axis--x .tick:nth-last-child(2) line, */ #chartPrint .axis--x .tick:first-child line,
#chartPrint .axis--y1 .tick:nth-last-child(2) line, #chartPrint .axis--y2 .tick:nth-last-child(2) line, #chartPrint .axis--y3 .tick:nth-last-child(2) line
#chartPrint .axis--y1 .tick:first-child line, #chartPrint .axis--y2 .tick:first-child line, #chartPrint .axis--y3 .tick:first-child line
 {
  stroke: black;
  stroke-dasharray: none;
  stroke-width: 2.0px;
}

#chartPrint .axis--y1 .tick:nth-last-child(2) text, #chartPrint .axis--y2 .tick:nth-last-child(2) text, #chartPrint .axis--y3 .tick:nth-last-child(2) text {
  transform: translate(0px, 10px);
  visibility: visible;
}

#chartPrint .axis--y1 .tick:first-child text, #chartPrint .axis--y2 .tick:first-child text, #chartPrint .axis--y3 .tick:first-child text {
  transform: translate(0px, -10px);
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/PrintVersion.vue